import { createRemoteComponent } from '@remote-ui/core';

/**
 * BlockStack is used to vertically stack elements.
 */
const BlockStack = createRemoteComponent('BlockStack');

export { BlockStack };
